import { render } from "./EditAddressModal.vue?vue&type=template&id=79bbfa82"
import script from "./EditAddressModal.vue?vue&type=script&lang=js"
export * from "./EditAddressModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__